import React from 'react';
import { Skeleton } from 'components/ui/skeleton';

function Placeholder({ className }: { className: string }) {
  return <Skeleton className={`motion-reduce:animate-none ${className}`} />;
}

export default function WorkspaceSkeleton() {
  return (
    <section
      role="status"
      aria-label="Carregando controle de estadia"
      aria-busy="true"
      className="rounded-lg border border-gray-200 bg-gray-100 p-6"
    >
      <span className="sr-only">Carregando viagens e indicadores…</span>
      <div aria-hidden="true" className="space-y-6">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="space-y-3">
            <Placeholder className="h-3 w-36" />
            <Placeholder className="h-8 w-64 max-w-full" />
            <Placeholder className="h-4 w-72 max-w-full" />
          </div>
          <Placeholder className="h-10 w-36" />
        </div>
        <div className="grid grid-cols-1 gap-4 rounded-md border border-gray-200 bg-white p-4 sm:grid-cols-2 lg:grid-cols-4">
          {[0, 1, 2, 3].map((index) => (
            <div key={index} className="space-y-2">
              <Placeholder className="h-3 w-24" />
              <Placeholder className="h-10 w-full" />
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          {[0, 1, 2, 3].map((index) => (
            <div
              key={index}
              className="space-y-5 rounded-md border border-gray-200 bg-white p-5"
            >
              <Placeholder className="h-4 w-32" />
              <Placeholder className="h-8 w-20" />
              <Placeholder className="h-4 w-full" />
            </div>
          ))}
        </div>
        <div className="overflow-hidden rounded-md border border-gray-200 bg-white">
          <div className="space-y-3 border-b border-gray-200 p-5">
            <Placeholder className="h-6 w-36" />
            <Placeholder className="h-4 w-56 max-w-full" />
          </div>
          {[0, 1, 2].map((index) => (
            <div
              key={index}
              className="grid grid-cols-1 items-center gap-6 border-b border-gray-200 p-5 last:border-b-0 md:grid-cols-6"
            >
              <div className="space-y-3">
                <Placeholder className="h-5 w-24" />
                <Placeholder className="h-3 w-full" />
              </div>
              <div className="space-y-5 md:col-span-3">
                <div className="flex justify-between gap-4">
                  <Placeholder className="h-4 w-24" />
                  <Placeholder className="h-4 w-24" />
                </div>
                <Placeholder className="h-7 w-full" />
              </div>
              <Placeholder className="h-7 w-full" />
              <Placeholder className="h-7 w-full" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
